import React from "react";
import { t } from "i18next";

export default function AddressInfo() {
    return (
        <div>
            <h3 className="text-base font-semibold text-gray-800 mb-5">{t('addresses')}</h3>
            <div className="flex flex-col items-center justify-center py-12 text-center">
                <div className="w-14 h-14 rounded-2xl bg-gray-100 flex items-center justify-center mb-4">
                    <svg viewBox="0 0 24 24" fill="none" className="w-7 h-7 text-gray-400" stroke="currentColor" strokeWidth="1.5">
                        <path d="M12 2C8.134 2 5 5.134 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.866-3.134-7-7-7z" strokeLinecap="round" strokeLinejoin="round" />
                        <circle cx="12" cy="9" r="2.5" />
                    </svg>
                </div>
                <p className="text-gray-500 text-sm">{t('comingSoon')}</p>
            </div>
        </div>
    );
}
